export function maskName(value: string | undefined) {
  if (!value) return '';

  const numbersRegex = /[0-9]/g;
  return value?.replace(numbersRegex, '');
}
